import type { FormEvent } from 'react'
import { AleloButton, AleloError, AleloInput } from '@/components/AleloLayout'
import styles from '@/components/AleloLayout.module.css'

/**
 * Formulário de OTP — apresentacional puro.
 *
 * Não conhece Universal Login nem `useMfaOtpManager`: serve tanto as telas de
 * MFA pós-login quanto as sub-etapas de confirmação do cadastro, que falam com
 * o BFF. Toda a decisão de fluxo fica em quem renderiza.
 */
export type OtpFormProps = {
  /** Enrollment de SMS pede o telefone em vez do código. */
  askPhone?: boolean
  code: string
  onCodeChange: (value: string) => void
  codePlaceholder: string
  /** Dígitos aceitos no campo de código. */
  codeMaxLength?: number
  phone?: string
  onPhoneChange?: (value: string) => void
  phonePlaceholder?: string
  error?: string
  submitLabel: string
  pending?: boolean
  onSubmit: (event: FormEvent) => void
  /** Sem rótulo de reenvio, o botão de reenviar não aparece. */
  resendLabel?: string
  resendSeconds?: number
  resendDisabled?: boolean
  onResend?: () => void
}

export function OtpForm({
  askPhone = false,
  code,
  onCodeChange,
  codePlaceholder,
  codeMaxLength = 8,
  phone = '',
  onPhoneChange,
  phonePlaceholder,
  error,
  submitLabel,
  pending = false,
  onSubmit,
  resendLabel,
  resendSeconds = 0,
  resendDisabled = false,
  onResend,
}: OtpFormProps) {
  return (
    <form className={styles.stack} onSubmit={onSubmit} noValidate>
      {askPhone ? (
        <AleloInput
          id="phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          placeholder={phonePlaceholder}
          value={phone}
          onChange={(e) => onPhoneChange?.(e.target.value)}
        />
      ) : (
        <AleloInput
          id="otp"
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder={codePlaceholder}
          value={code}
          onChange={(e) =>
            onCodeChange(e.target.value.replace(/\D/g, '').slice(0, codeMaxLength))
          }
          maxLength={codeMaxLength}
        />
      )}
      <AleloError message={error} />
      <AleloButton type="submit" disabled={pending}>
        {submitLabel}
      </AleloButton>
      {resendLabel && (
        <div className={styles.center}>
          <AleloButton
            variant="link"
            type="button"
            disabled={pending || resendDisabled}
            onClick={() => onResend?.()}
          >
            {resendDisabled && resendSeconds > 0
              ? `${resendLabel} (${resendSeconds}s)`
              : resendLabel}
          </AleloButton>
        </div>
      )}
    </form>
  )
}
